import { render, staticRenderFns } from "./AdminCampaignReActivateActionsPrompt.vue?vue&type=template&id=9d0a993a&scoped=true"
import script from "./AdminCampaignReActivateActionsPrompt.vue?vue&type=script&lang=js"
export * from "./AdminCampaignReActivateActionsPrompt.vue?vue&type=script&lang=js"
import style0 from "./AdminCampaignReActivateActionsPrompt.vue?vue&type=style&index=0&id=9d0a993a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0a993a",
  null
  
)

export default component.exports